﻿import * as React from 'react';

import { FormCheckProps, FormCheckType } from 'react-bootstrap/esm/FormCheck';
import { ToolTip } from 'components/ToolTip/ToolTip';

import 'components/GMetrixCheckInput/gmetrix-checkinput.scss';

import { Form } from 'react-bootstrap';
import { useStableId } from 'hooks';

interface GMetrixCheckInputProps extends FormCheckProps {
    className?: string;
    description?: string;
    infoTitle?: string;
    label: any;
    readOnly?: boolean;
    subLabel?: string;
    type: FormCheckType;
    value?: any;
}

export const GMetrixCheckInput = ({
    className,
    description,
    disabled,
    infoTitle,
    label,
    readOnly,
    required,
    subLabel,
    type,
    value,
    ...otherProps
}: GMetrixCheckInputProps) => {

    // A stable, unique id guarantees the rendered <input>/<label> pair is correctly
    // associated even when the label is a non-string node or repeated on the page.
    const checkId = useStableId('gmx-check');

    return (
        <Form className={`${className ? className : ''}`}>
            <Form.Group className="align-items-center d-flex">
                <Form.Check
                    label={(
                        <>
                            <Form.Label className="ms-2 m-0 fw-bold">
                                {label}
                            </Form.Label>
                            {subLabel && (
                            <small className="text-muted ms-2 mb-2">
                                {subLabel}
                            </small>
                            )}

                        </>
                    )}
                    aria-required={required ? true : undefined}
                    disabled={disabled}
                    id={checkId}
                    readOnly={readOnly}
                    required={required}
                    type={type}
                    value={value}
                    {...otherProps}
                />
                {infoTitle && <ToolTip className="mb-1" content={infoTitle} />}
            </Form.Group>
            <Form.Control.Feedback>
                {description}
            </Form.Control.Feedback>
        </Form>
    );

};
